import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiltroAvanzadoComponent } from './filtro-avanzado.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PqrService } from '../../servicios/pqr/pqr.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [FiltroAvanzadoComponent],
  exports: [FiltroAvanzadoComponent],
  providers: [
    PqrService
  ]
})
export class FiltroAvanzadoModule { }



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/filtro-avanzado/filtro-avanzado.module.ts